import 'bootstrap/dist/css/bootstrap.css'

import "@fortawesome/fontawesome-free/css/all.min.css";

import "flag-icon-css/css/flag-icon";
import "landing/style/master.scss";

import "jquery/dist/jquery.js"
import "bootstrap/dist/js/bootstrap.bundle.js"

import "@fancyapps/fancybox/dist/jquery.fancybox.js"
import "@fancyapps/fancybox/dist/jquery.fancybox.min.css"
import "leaflet/dist/leaflet.js"
import "leaflet/dist/leaflet.css"
import "website/maps.js"
import "website/trip.js"
import "website/trip.css"